// extracted by mini-css-extract-plugin
module.exports = {"custom_scrollbar":"custom_scroll_custom_scrollbar__3TMcf","isMobile":"custom_scroll_isMobile__1meCS"};